import React, { useState } from 'react';
import { uploadImage } from '../../utils/storage';
import { Button } from './Button';
import SafeIcon from '../../common/SafeIcon';

export const ImageUpload = ({ onUpload, currentUrl, label }) => {
  const [uploading, setUploading] = useState(false);

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Basic client-side validation
    if (file.size > 2 * 1024 * 1024) {
      alert('File is too large. Max 2MB allowed.');
      return;
    }

    setUploading(true);
    try {
      const url = await uploadImage(file);
      if (url) {
        onUpload(url);
      }
    } catch (err) {
      console.error('Upload component error:', err);
      alert('Failed to upload image. Please ensure your Supabase storage is configured.');
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="flex flex-col gap-2">
      {label && <label className="text-xs font-medium text-gray-400">{label}</label>}
      <div className="flex items-center gap-4">
        <div className="w-16 h-16 rounded-xl bg-base-800 border border-base-700 flex items-center justify-center overflow-hidden shrink-0 shadow-inner">
          {currentUrl ? (
            <img src={currentUrl} className="w-full h-full object-cover" alt="Preview" />
          ) : (
            <SafeIcon name="Image" className="w-6 h-6 text-gray-600" />
          )}
        </div>
        
        <div className="flex-1">
          <input 
            type="file" 
            accept="image/*" 
            className="hidden" 
            id="image-upload-input" 
            onChange={handleFileChange}
            disabled={uploading}
          />
          <div className="flex gap-2">
            {/* The "as='div'" prop is now supported by our updated Button component */}
            <label htmlFor="image-upload-input" className="block cursor-pointer">
              <Button 
                variant="secondary" 
                as="div" 
                disabled={uploading}
                className={uploading ? 'opacity-50 pointer-events-none' : ''}
              >
                <SafeIcon name={uploading ? 'Loader' : 'Upload'} className={`w-4 h-4 ${uploading ? 'animate-spin' : ''}`} />
                {uploading ? 'Uploading...' : 'Upload Image'}
              </Button>
            </label>
            {currentUrl && (
              <Button variant="ghost" onClick={() => onUpload('')} className="text-red-400 hover:bg-red-400/10">
                Remove
              </Button>
            )}
          </div>
          <p className="text-[10px] text-gray-500 mt-2">Recommended: Square PNG/JPG, max 2MB.</p>
        </div>
      </div>
    </div>
  );
};